import React, { FunctionComponent, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { WIDGET_SETTINGS_API_URL } from "../../api/ApiConstant";
import WidgetSettingContext from "../../Context/WidgetSettingContext";
import { GLOBAL_OBJECT_TYPE, SettingsType } from "../../types/Types";
import axiosInstance from "../../utils/axios";
import Dashboard from "../Dashboard/Dashboard";
import { LoginSignUp } from "../LoginSignUp/LoginSignUp";
import { QueryClient, QueryClientProvider } from "react-query";

type Props = {
  globalObject: GLOBAL_OBJECT_TYPE;
};
const AppContainer: FunctionComponent<Props> = ({ globalObject }) => {
  const queryClient = new QueryClient();

  const [widgetSettingState, setWidgetSettingState] = useState({
    widget_position: "left",
    app_title: "",
    global_color: {
      primary_color: "#772BFF",
      text_color: "#FFFFFF",
    },
    body_background_color: "#FFFFFF",
    heading_color: "#212B36",
    body_text_color: "#637381",
    accent_color: "#E9F5FE",
    widget_icon:
      "data:image/png;base64,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",
  });

  const fetchWidgetSettings = async (storeUrl: string) => {
    try {
      const { data } = await axiosInstance.get<SettingsType>(
        `${WIDGET_SETTINGS_API_URL}?mwb_app_store_url=${storeUrl}`
      );
      if (data.data) {
        setWidgetSettingState({ ...data.data });
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchWidgetSettings(globalObject.storeUrl);
  }, [globalObject.storeUrl]);

  const getStyle = () => {
    return (
      <style>
        {`
          .par-ecom-widget__nav-link.nav-link--active,
          .primary-bg-color {
              background-color: ${
                widgetSettingState.global_color.primary_color
              };
              color: ${widgetSettingState.global_color.text_color};
          }

          .par-ecom-btn {
            border: 1px solid ${widgetSettingState.global_color.primary_color};
          }

          .par-ecom__loader-spin::before {
            background-color: ${widgetSettingState.global_color.primary_color};
          }

          .par-ecom__loader-text,
          .par-ecom-widget__modal-title {
            color: ${widgetSettingState.global_color.primary_color};
          }

          .par-ecom-widget__header-title,
          .par-ecom-widget__list-item.primary-bg-color .par-ecom-widget__list-text {
            color: ${widgetSettingState.global_color.text_color};
          }
          
          .par-ecom-widget__list-item.primary-bg-color .par-ecom-widget__list-leading-icon svg path,
          .par-ecom-widget__list-item.primary-bg-color .par-ecom-widget__list-trailing-icon svg path {
            fill: ${widgetSettingState.global_color.text_color};
          }
          .par-ecom-widget__main,
          .par-ecom-widget__modal,
          .par-ecom-widget__nav-list {
            background-color: ${widgetSettingState.body_background_color};
          }

          body,
          p,
          .par-ecom-widget__list-help-text,
          .par-ecom-widget__nav-link {
            color: ${widgetSettingState.body_text_color};
          }

          h1,
          h2,
          h3
          h4,
          h5,
          h6,
          .par-ecom-widget__list-text,
          .par-ecom-widget__label,
          .par-ecom-widget__active-reward-title>h2,
          .par-ecom-widget__your-activity-title>h2,
          .par-ecom-widget__list-label,
          .par-ecom-widget__code-text,
          .par-ecom-widget__help-text,
          .par-ecom-widget__modal-form-group label,
          .par-ecom-widget__table th,
          input[type="text"],
          input[type="date"] {
            color: ${widgetSettingState.heading_color};
          }

          .btn-filled {
            border: 1px solid ${widgetSettingState.global_color.primary_color};
          }

          .btn--outlined {
            border: 1px solid ${widgetSettingState.global_color.primary_color};
            color: ${widgetSettingState.global_color.primary_color}
          }

          .par-ecom-widget__container::-webkit-scrollbar-thumb {
            background-color: ${widgetSettingState.global_color.primary_color};
          }

          .nav-tab--earn-points .par-ecom-widget__list-trailing-icon svg path,
          .nav-tab--earn-points .par-ecom-widget__list-leading-icon svg path,
          .nav-tab--rewards .par-ecom-widget__list-trailing-icon svg path,
          .nav-tab--rewards .par-ecom-widget__list-leading-icon svg path,
          .par-ecom-widget__active-reward-title-icon svg path,
          .par-ecom-widget__list-leading-icon svg path,
          .par-ecom-widget__list-trailing-icon svg path,
          .par-ecom-widget__your-activity-title-icon svg path {
            fill: ${widgetSettingState.global_color.primary_color};
          }

          .par-ecom-widget__list-trailing-icon svg rect {
            fill: ${widgetSettingState.global_color.primary_color};
          }

          .par-ecom-widget__list .par-ecom-widget__list-trailing-icon svg rect+path {
            fill: ${widgetSettingState.global_color.text_color};
          }

          .par-ecom__referral-form-group input[type="text"],
          .form-discount .par-ecom-widget__modal-form-field input[type="text"],
          .form-acitive-reward__discount .par-ecom-widget__modal-form-field input[type="text"],
          .par-ecom-widget__container::-webkit-scrollbar,
          .par-ecom-widget__modal-form-group input[type="date"],
          .par-ecom-widget__code-wrap,
          .accent-color {
            background-color: ${widgetSettingState.accent_color};
          } 
          
          .par-ecom-widget__table table td {
            border-bottom: 1px solid ${widgetSettingState.accent_color};
          }
          .par-ecom-widget__rewards-position{
            ${
              widgetSettingState.widget_position === "right"
                ? "margin-left: auto"
                : "margin-right: auto"
            }
            
          }
          .par-ecom-widget-transform{
            transform-origin: ${
              widgetSettingState.widget_position === "left"
                ? "bottom left"
                : "bottom right"
            }
          }
          `}
      </style>
    );
  };

  return (
    <>
      <WidgetSettingContext.Provider
        value={{ colorsState: widgetSettingState }}
      >
        {getStyle()}
        {globalObject.customerEmail ? (
          <QueryClientProvider client={queryClient}>
            <ToastContainer />
            <div className="widget-wrapper">
              <div className="par-ecom">
                <Dashboard globalObject={globalObject} />
              </div>
            </div>
          </QueryClientProvider>
        ) : (
          <div className="widget-wrapper">
            <div className="par-ecom">
              <LoginSignUp
                loginUrl={globalObject.storeLoginUrl}
                registerUrl={globalObject.storeRegisterUrl}
              />
            </div>
          </div>
        )}
      </WidgetSettingContext.Provider>
    </>
  );
};

export default AppContainer;
